import { DeviceDiagnosticsListContent } from '../device-diagnostics-list-content/DeviceDiagnosticsListContent.ctrl';
import { LogicalDeviceHistoryTab } from '../logical-device-history-tab/LogicalDeviceHistoryTab.ctrl';
import { DeviceCallLogPage } from '../../pages/device-call-log-page/DeviceCallLogPage.ctrl';
import { DeviceDiagnosticPage } from '../../pages/device-diagnostic-page/DeviceDiagnosticPage.ctrl';
import { withDeviceManagementContainer } from '../../utils/withDeviceManagementContainer.util';

export const ExposedLogicalDeviceHistoryTab = withDeviceManagementContainer(LogicalDeviceHistoryTab);
export const ExposedLogicalDeviceDiagnosticsTab = withDeviceManagementContainer(DeviceDiagnosticsListContent);
export const ExposedLogicalDeviceCallLogPage = withDeviceManagementContainer(DeviceCallLogPage);
export const ExposedLogicalDeviceDiagnosticPage = withDeviceManagementContainer(DeviceDiagnosticPage);
